export default __webpack_public_path__ + "static/media/sandman.689eee33.jpeg";